import type { NotificationInstance } from 'antd/es/notification/interface'
import notification from 'antd/es/notification'

// Set by GlobalNotificationHolder, which is mounted inside the app's
// ConfigProvider. Lets non-React modules notify through a context-aware
// instance instead of the static API, which ignores the theme context.
let globalNotificationApi: NotificationInstance | null = null

export function setGlobalNotificationApi(api: NotificationInstance) {
  globalNotificationApi = api
}

// Falls back to the static API when called before the holder mounts, so an
// early failure still surfaces something rather than nothing.
export function notifyError(message: string, description: string) {
  const api = globalNotificationApi ?? notification
  api.error({ message, description, placement: 'topRight' })
}
